{
  "$schema": "./ports.schema.json",
  "version": "1.0",
  "doc": "Single source of truth for LOCAL-DEV port assignments. Cloud environments use HTTPS:443 (see domains.json for the URLs). Editing this file is the canonical way to move a port — every consumer (firebase.json, scripts/start.sh, the leanopx-workflow-test skill's pre-flight, app .env templates) reads from here and `scripts/validate-ports.mjs` catches drift in CI.",
  "local": {
    "portal": {
      "port": 5180,
      "service": "vite",
      "purpose": "apps/web dev server (the React SPA)"
    },
    "marketing": {
      "port": 5181,
      "service": "vite",
      "purpose": "apps/marketing dev server"
    },
    "functions": {
      "port": 5001,
      "service": "firebase-emulator",
      "purpose": "Cloud Functions emulator — /api routes through this"
    },
    "auth": {
      "port": 9099,
      "service": "firebase-emulator",
      "purpose": "Firebase Auth emulator"
    },
    "firestore": {
      "port": 8085,
      "service": "firebase-emulator",
      "purpose": "Firestore emulator (HTTP). Moved off 8080 in May 2026 because that port is shared with `ops-matrix-temporal-ui` on co-running OpsMatrix dev stacks; 8085 is unclaimed."
    },
    "hosting": {
      "port": 5002,
      "service": "firebase-emulator",
      "purpose": "Firebase Hosting emulator. Moved off the Firebase default :5000 because macOS AirPlay Receiver claims that port on most dev boxes."
    },
    "emulator-ui": {
      "port": 4000,
      "service": "firebase-emulator",
      "purpose": "Firebase Emulator Suite UI (the all-in-one inspector at http://localhost:4000)"
    },
    "storage": {
      "port": 9199,
      "service": "firebase-emulator",
      "purpose": "Firebase Storage emulator"
    },
    "rules-test": {
      "port": 8765,
      "service": "firebase-emulator",
      "purpose": "Firestore rules unit-test emulator (isolated from :8085 so `pnpm test:rules` doesn't collide with `dev:local`)"
    },
    "neo4j-bolt": {
      "port": 7687,
      "service": "docker",
      "purpose": "Neo4j bolt protocol (the driver talks this) — docker-compose container in dev:local, real Aura in dev (cloud-connected)"
    },
    "neo4j-http": {
      "port": 7474,
      "service": "docker",
      "purpose": "Neo4j HTTP UI (browser at http://localhost:7474 for ad-hoc cypher)"
    }
  }
}
